import template from './sw-cms-block-image-text-gallery.html.twig';
import './sw-cms-block-image-text-gallery.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
